import { render, staticRenderFns } from "./formsub.vue?vue&type=template&id=1390ac73&scoped=true"
import script from "./formsub.vue?vue&type=script&lang=js"
export * from "./formsub.vue?vue&type=script&lang=js"
import style0 from "./formsub.vue?vue&type=style&index=0&id=1390ac73&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1390ac73",
  null
  
)

export default component.exports